import { Component, Input } from '@angular/core';
import { MtplDriverInfo } from 'src/app/models/app/Interfaces/mtplDriverInfo.interface';
import { StepStateOptions } from 'src/app/models/app/step-state-options';
import { ProductTypes } from 'src/app/models/enums/product-types';
import { QuoteSteps } from 'src/app/models/enums/quote-steps';
import { GoogleTagManagerService } from 'src/app/services/google-analytics/google-tag-manager.service';
import { ModalService } from 'src/app/services/modal-service/modal.service';
import { MotorQuoteStateService } from 'src/app/services/motor-quote-state/motor-quote-state.service';
import * as strings from "./mtpl-confirm-modal.component.strings";
import { QuoteInfoService } from 'src/app/services/quote-info/quote-info.service';
import { MtplHelperService } from 'src/app/services/mtpl-helper/mtpl-helper.service';
import { BaseModalComponent } from '../base-modal/base-modal.component';

export class MtplConfirmModalActionsVm {
    customAction: ((val: string) => any) | undefined;
    formValue: any;
    driverInfoList: any = [];
}

@Component({
    selector: 'app-mtpl-confirm-modal',
    templateUrl: './mtpl-confirm-modal.component.html',
    styleUrl: './mtpl-confirm-modal.component.scss',
    imports: [BaseModalComponent]
})
export class MtplConfirmModalComponent {
    @Input() inProcessModal: boolean = false;
    @Input() set inputs(value: MtplConfirmModalActionsVm) {
        this.modalActions = value;
    }

    modalActions: MtplConfirmModalActionsVm = new MtplConfirmModalActionsVm();
    s = strings;

    constructor(private readonly motorQuoteStateService: MotorQuoteStateService,
        private readonly mtplHelperService: MtplHelperService,
        private readonly modalService: ModalService,
        private readonly quoteInfoService: QuoteInfoService,
        private readonly googleTagManagerService: GoogleTagManagerService
    ) {
        this.triggerGtmEvent('pop_up', 'open', 'mtpl-confirm-modal', 'mtpl-confirm-modal');
    }

    closeModal() {
        this.mtplHelperService.setCanDeactivateMtpl(false);
        this.modalService.dismissAll();
    }

    saveInputs() {
        const drivers = this.modalActions.driverInfoList;
        const driversFormVals = this.modalActions.formValue;
       for (const element of driversFormVals) {
            const filterDrivers = drivers.findIndex((driver: MtplDriverInfo) => driver.driverIndex === element.driverIndex);
            drivers[filterDrivers]['licenceNumber'] = element.driverNumber;
            drivers[filterDrivers]['licenceCountry'] = element.country;
        }

        if (this.modalActions?.customAction) {
            this.modalActions.customAction(drivers);
        }

        this.mtplHelperService.setCanDeactivateMtpl(true);
        this.modalService.dismissAll();
        this.routeNavigate();
        this.triggerGtmEvent('pop_up', 'save', 'mtpl-confirm-modal', 'mtpl-confirm-modal');
    }

    contiunueWithoutSave() {
        const drivers = this.modalActions.driverInfoList;
        const driversFormVals = this.modalActions.formValue;
         for (const driverFormVal of driversFormVals) {
            const filterDrivers = drivers.findIndex((driver: MtplDriverInfo) => driver.isSaved === false && driver.driverIndex == driverFormVal.driverIndex);
            drivers[filterDrivers]['licenceNumber'] = null;
            drivers[filterDrivers]['licenceCountry'] = null;
        }

        if (this.modalActions?.customAction) {
            this.modalActions.customAction(drivers);
        }

        this.mtplHelperService.setCanDeactivateMtpl(true);
        this.modalService.dismissAll();
        this.routeNavigate();
        this.triggerGtmEvent('pop_up', 'continue', 'mtpl-confirm-modal', 'mtpl-confirm-modal');
    }

    routeNavigate() {
        let options = new StepStateOptions();
        options.backNavigate = true;
        options.setReset = false;
        if (this.quoteInfoService.getSelectedProductType() === ProductTypes.telematics) {
            this.motorQuoteStateService.setStepState(QuoteSteps.blackBoxDetails, options);
        } else {
            this.motorQuoteStateService.setStepState(QuoteSteps.cica, options);
        }
    }

    triggerGtmEvent(event: string, action: string, html_id: string, name: string) {
        this.googleTagManagerService.trackAction({
            event: event,
            action: action,
            html_id: html_id,
            name: name
        });
    }
}
